import React from 'react';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import formatPossessiveProperNoun from '@/utils/translations/formatPossessiveProperNoun';
import interpolate from '@/utils/translations/interpolate';
import { formatDateForDisplay } from '@/utils/dates/dateFormatters';
import { useLocale } from 'next-intl';
import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';
import { TypeChildRecord } from '@/lib/api/accountManager/types';
import { DisplayDateFormat } from '@/utils/dates/constants';

export interface SubscriptionPageHeadingProps {
  t: TypePlayKitPageTranslations;
  selectedChild?: TypeChildRecord;
}

function SubscriptionPageHeading({
  t,
  selectedChild,
}: SubscriptionPageHeadingProps) {
  const locale = useLocale();

  return (
    <div className="md:text-center text-left mb-10 mt-6">
      {selectedChild ? (
        <>
          <Heading
            tag={HeadingTag.H1}
            size={HeadingSize.H1}
            classes="pb-2.5"
            text={interpolate(t.childsPlayKits, {
              childName: formatPossessiveProperNoun(selectedChild.name, locale),
            })}
            data-testid="subscription-page-heading"
          />
          <p>
            <span className="font-bold">{interpolate(t.birthdate)}</span>
            {formatDateForDisplay(
              selectedChild.birthday,
              locale,
              DisplayDateFormat.NumericMonthDayYear,
            ) || ''}
          </p>
        </>
      ) : (
        <Heading
          tag={HeadingTag.H1}
          size={HeadingSize.H1}
          classes="pb-2.5"
          text={t.noActiveSubscriptions}
        />
      )}
    </div>
  );
}

export default SubscriptionPageHeading;
